import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "date-time-field",
  templateUrl: "date-time-field.component.html",
})
export class DateTimeFieldComponent {
  @Input() formGroup: FormGroup;
  @Input() dateControlName: string;
  @Input() timeControlName: string;
  @Input() dateLabel: string;
  @Input() timeLabel: string;
  @Input() isReadOnly: boolean = false;
  @Input() maxDateValue?: any;
  @Input() minDateValue?: any;
  @Input() showValidation?: boolean = true;
  @Input() popupPlacement: string[] = ["bottom"];

  /**
   * Determines whether to show validation errors
   * If showValidation input is provided, use it
   * Otherwise, derive from form state (touched or dirty)
   */
  shouldShowValidation(controlName: string): boolean {
    // If parent explicitly sets showValidation, use that
    if (this.showValidation !== undefined) {
      return this.showValidation;
    }

    // Otherwise, show validation after user interaction
    const control = this.formGroup.get(controlName);
    return control && (control.touched || control.dirty);
  }

  hasError(controlName: string, errorType: string): boolean {
    const control = this.formGroup.get(controlName);
    return control && control.hasError(errorType);
  }
}



// WEBPACK FOOTER //
// ./src/components/date-time-field/date-time-field.component.ts